import auth from './auth';
import company from './company';
import users from './users';
import invoice from './invoice';
import client from './client';
import catalogs from './catalogs';
import statistics from './statistics';
import invoices from './invoices';
import employees from './employees';
import customers from './customers';
import sync from './sync';
import balances from './balances';
import messages from './messages';

export default {
  auth,
  company,
  users,
  invoice,
  client,
  catalogs,
  statistics,
  invoices,
  employees,
  customers,
  sync,
  balances,
  messages,
};
